<template>
  <div class="risk-release">
    <div class="risk-release-container">
      <div class="title">发布设置</div>
      <div class="risk-release-content">
        <el-steps :active="active" align-center>
          <el-step title="风险任务设置"></el-step>
          <el-step title="选择单位"></el-step>
        </el-steps>

        <!-- 风险任务设置 -->
        <div v-if="active == 1" class="step-content">
          <el-form
            :model="form"
            :rules="rules"
            ref="form"
          >
            <el-form-item label="任务名称：" prop="taskName">
              <el-input class="gray white" v-model="form.taskName"></el-input>
            </el-form-item>
            <el-form-item label="发布时间：" prop="date">
              <el-date-picker
                v-model="form.date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                class="white"
                clearable>
              </el-date-picker>
            </el-form-item>
            <div class="select-type">
              <div v-if="editableTabs.length>0" class="border"></div>
              <div v-if="editableTabs.length>0" class="right-border"></div>
              <el-tabs
                v-if="editableTabs.length>0"
                v-model="editableTabsValue"
                type="card"
                @tab-click="tabClick">
                <el-tab-pane
                  v-for="(item, index) in editableTabs"
                  :key="index"
                  :label="item.title"
                  :name="item.name"
                >
                  <span slot="label">
                    <span class="span-box">
                      <span>{{ item.title }}</span>
                      <img v-if="item.selectList.length>0" class="check-sign" src="../../../../assets/risk/check-sign.png">
                    </span>
                  </span>
                  <div class="select-container">
                    <el-checkbox-group v-model="item.selectList" @change="changeCheckbox">
                      <div v-for="(item, index) in checkList" :key="index" class="select-check-box">
                        <el-checkbox  :label="item.id">{{item.name}}</el-checkbox>
                      </div>
                    </el-checkbox-group>
                    <div class="nothing" v-if="checkList.length == 0">
                      <div>
                        <div>
                          <img src="../../../../assets/nothing.png">
                        </div>
                        <p>暂无数据</p>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div class="details-nums">
              已选风险细项（{{selectNums}}个）
            </div>
          </el-form>
        </div>

        <!-- 选择单位 -->
        <div v-if="active == 2" class="step2-content">
          <div class="select-company" v-for="(item,index) in tableList" :key="index">
            <div class="select-company-top">
              <div class="select-company-title">
                <div>
                  <span>{{item.title}}</span>
                  <span v-if="item.type != 2">({{item.checkedList.length}})</span>
                </div>
                <el-button :disabled="item.type == 2 && item.checkedList.length>0" class="btn-text" :class="(item.type == 2 && item.checkedList.length>0)?'activeBtn':''" type="text" icon="el-icon-plus" @click="add(index, item.type)">添加</el-button>
              </div>
            </div>
            <div class="lable-name">
              <div class="checkbox-title">
                <el-checkbox v-if="item.type != 2" v-model="item.checkAll" @change="checked=>handleCheckAllChange(checked, index)"></el-checkbox>
                <span>{{item.prop}}</span>
              </div>
              <span class="operation">操作</span>
            </div>
            <div class="select-container">
              <div class="checkbox-title">
                <el-checkbox-group v-if="item.type != 2" v-model="item.selectList" @change="checked=>handleCheckedCitiesChange(checked, index)">
                  <div class="checkbox-row" v-for="(v, idx) in item.checkedList" :key="idx">
                    <el-checkbox :label="v.id">
                      {{v.name}}
                    </el-checkbox>
                    <el-button class="btn-text operation-btn" type="text" @click="remove(index, idx)"
                      >移除</el-button
                    >
                  </div>
                </el-checkbox-group>
                <div v-else>
                  <div class="checkbox-row" v-for="(v, idx) in item.checkedList" :key="idx">
                    {{v.name}}
                    <el-button class="btn-text operation-btn" type="text" @click="remove(index, idx)"
                      >移除</el-button
                    >
                  </div>
                </div>
              </div>
              <el-button v-if="item.type != 2 && item.checkedList.length > 0" class="btn-blue all-remove" type="primary" @click="allRemove(index, item.type)"
                >移除选中人选</el-button
              >
            </div>
          </div>
        </div>
      </div>

      <div class="foot">
        <el-button v-if="active < 2" class="btn-blue" type="primary" @click="next('form')"
          >下一步</el-button
        >
        <el-button v-if="active == 2" class="btn-blue" type="primary" @click="prev"
          >上一步</el-button
        >
        <el-button
          v-if="active == 2"
          class="btn-border-text-blue"
          type="primary"
          @click="save"
          >发布</el-button
        >
      </div>
    </div>

    <!-- 选择单位 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="940px"
      :before-close="closeDialog"
    >
      <div class="stayDistribution">
        <div class="table-right">
          <p class="title">{{tips}}</p>
          <div class="tree-container">
            <tree
              :isSearch="isSearch"
              :companyList="departmentList"
              :departmentId="departmentId"
              @selectTreeNodeList="selectTreeNodeList"
            />
          </div>
        </div>
        <div class="table table-left">
          <div class="search-table">
            <el-input
              class="gray white"
              @keyup.enter.native="initStaffList"
              v-model="staff"
              placeholder="请输入成员"
            ></el-input>
          </div>
          <el-table
            :data="assignPeople"
            style="width: 100%;"
            height="250"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column prop="name" label="姓名">
              <template slot-scope="scope">
                <div class="assign-name">
                  <img :src="scope.row.img">
                  <span>{{ scope.row.name }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="手机号"></el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { config } from "@/common/js/config.js";
import { mapChild, mapId2, treeFindPath} from "@/common/js/utils.js";
import Tree from "@/components/Tree.vue";
import Department from "@/models/department.js";
import Risk from "@/models/risk.js";
import Salary from "@/models/salary.js";
export default {
  components: {
    Tree,
  },

  data() {
    return {
      active: 1,
      tableData: [],
      dialogVisible: false,
      secondDeptmentId: '',
      form: {
        taskName: '',
        date: '',
      },
      rules: {
        taskName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        date: [{ required: true, message: "请选择日期", trigger: "change" }],
      },
      editableTabsValue: "",
      editableTabs: [],
      checkList: [],
      typeId: '',
      selectNums: 0,
      tableList: [
        {
          type:1, title: '已添加人员', prop: '执行人', selectList: [],
          checkAll: false, checkedList: []
        },
        {
          type:2, title: '最多添加1名人员', prop: '主要责任人', selectList: [],
          checkedList: []
        },
        {
          type:3, title: '已添加主体单位', prop: '风险责任主体单位', selectList: [],
          checkAll: false, checkedList: []
        }
      ],
      isSearch: false,
      assignPeople: [],
      departmentList: [],
      departmentId: 0,
      tips: '',
      title: '',
      staff: '',
      type: '',
      activeIndex: '',
      selectIdsList: []
    };
  },

  created() {
    config();
    this.initDapartmentList()
    this.initRiskTypeList()
  },

  methods: {
    /* 获取风险分类 */
    initRiskTypeList() {
      Risk.getRiskTypeLsit().then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.title = i.name
            obj.selectList = []
            obj.name = String(i.id)
            arr.push(obj)
          })
          this.editableTabs = arr
          if (arr.length>0) {
            this.typeId = arr[0].id
            this.editableTabsValue = arr[0].name
            this.initRiskDetails()
          }
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    initRiskDetails() {
      let riskId = this.typeId
      let data = {
        riskId
      }
      Risk.getRiskTaskDetailsList(data).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.name = i.content
            arr.push(obj)
          })
          this.checkList = arr
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    initDapartmentList() {
      let searchDepartment = ''
      let id = ''
      Department.getDepartmentList(id, searchDepartment).then(res => {
        if (res.success) {
          let arr = mapChild(res.result);
          this.departmentList = mapId2(arr)
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    initStaffList() {
      let id = this.departmentId
      let query = this.staff;
      Salary.getMember(id, query).then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            obj.id = i.id;
            obj.name = i.name;
            obj.img = i.image ? i.image : this.avater;
            obj.phone = i.phoneNo;
            arr.push(obj);
          });
          this.assignPeople = arr;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    
    tabClick(tab) {
      let obj = this.editableTabs[tab.index];
      this.typeId = obj.id
      this.initRiskDetails()
    },

    changeCheckbox() {
      let nums = 0
      this.editableTabs.map(i => {
        if (i.selectList.length>0) nums += i.selectList.length
      })
      this.selectNums = nums
    },

    next(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.active == 1) {
            let isSelectDetails = this.editableTabs.some(item => {return item.selectList.length > 0})
            if (!isSelectDetails) return this.$message.error('请先选择风险细项')
            this.active++
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    prev() {
      this.active--
    },

    selectTreeNodeList(v) {
      this.selectData = v
      this.departmentId = v.id
      this.initStaffList()
    },

    closeDialog() {
      this.selectData = [],
      this.assignPeople = []
      this.departmentId = 0
      this.dialogVisible = false
    },

    confirm() {
      let row = this.tableList[this.activeIndex]
      this.selectIdsList.map(i => {
        let obj = {}
          if (this.type != 3) {
            obj.name = `${i.name}(${i.departmentName})`
          } else {
            obj.name = `${i.departmentName}(${i.name})`
          }
          obj.id = i.id
          obj.deptId = i.deptId
          obj.thirdDeptId = i.thirdDeptId
          obj.teamId = i.teamId
          row.checkedList.push(obj)
      })
      this.closeDialog()
    },

    save() {
      let taskName = this.form.taskName
      let beginTime = this.form.date?this.form.date[0]:''
      let endTime = this.form.date?this.form.date[1]:''
      let riskEntityList = []
      let riskImplementEntityList = []
      let riskResponsibilityEntity = []
      let riskMainUnitEntityList = []
      this.editableTabs.map(i => {
        if (i.selectList.length>0) {
          let obj = {}
          obj.riskId = i.id
          obj.riskItemIdList = i.selectList
          riskEntityList.push(obj)
        }
      })
      this.tableList.map(i => {
        i.checkedList.map(v => {
          let obj = {}
          obj.userId = v.id
          obj.deptId = v.deptId
          if (i.type == 1) {
            riskImplementEntityList.push(obj)
          } else if (i.type == 2) {
            riskResponsibilityEntity.push(obj)
          } else {
            obj.teamId = v.teamId
            riskMainUnitEntityList.push(obj)
          }
        })
      })
      let isFlag = riskImplementEntityList.every(item => item.deptId == riskImplementEntityList[0].deptId)
      let isBelongToRiskResponsibilityEntityTeamId = riskMainUnitEntityList.every(item => item.teamId == riskResponsibilityEntity[0].deptId)
      if (riskImplementEntityList.length == 0) {
        return this.$message.error('请设置执行人')
      }
      if (riskResponsibilityEntity.length == 0) {
        return this.$message.error('请设置主要负责人')
      }
      if (riskMainUnitEntityList.length == 0) {
        return this.$message.error('请设置风险主体单位')
      }
      if (!isFlag) {
        return this.$message.error('不可以跨支队设置执行人')
      }
      if (riskResponsibilityEntity.length > 1) {
        return this.$message.error('最多可添加1名主要负责人')
      }
      if (!isBelongToRiskResponsibilityEntityTeamId) {
        return this.$message.error('风险主体单位不属于主要负责人所管辖的部门')
      }
      let data = {
        taskName,
        beginTime,
        endTime,
        riskEntityList,
        riskImplementEntityList,
        riskResponsibilityEntity: riskResponsibilityEntity[0],
        riskMainUnitEntityList
      }
      Risk.postPublishTask(data).then(res => {
        if (res.success) {
          this.$message.success('发布成功')
          this.$router.push({
            path: '/oneLevel/riskModuleIndex/riskReleaseIndex/riskReleaseList'
          })
        } else {
          this.$message.error(res.message)
        }
      })
    },

    add(index, type) {
      let title
      let tips
      if (type == 1) {
        title = '添加执行人'
        tips = '可添加多名同个二级单位内所属成员'
      } else if (type == 2) {
        title = '添加主要负责人'
        tips = '最多可添加1名成员'
      } else {
        title = '风险责任主体单位'
        tips = '可添加多个不同三级单位所属成员'
      }
      this.title = title
      this.tips = tips
      this.type = type
      this.activeIndex = index
      this.dialogVisible = true
    },

    /* 全选 */
    handleCheckAllChange(val, index) {
      let row = this.tableList[index]
      let selectList = []
      if (val) {
        row.checkedList.map(i => {
          selectList.push(i.id)
        })
      }
      this.$set(this.tableList[index], 'checkAll', val)
      this.$set(this.tableList[index], 'selectList', selectList)
    },

    handleCheckedCitiesChange(value, index) {
      let checkedCount = value.length;
      let checkAll = checkedCount === this.tableList[index].checkedList.length;
      this.$set(this.tableList[index], 'checkAll', checkAll)
      this.$set(this.tableList[index], 'selectList', value)
    },
    
    remove(index, idx) {
      let row = this.tableList[index]
      row.checkedList.splice(idx,1)
      if (row.checkedList.length == 0) {
        this.$set(this.tableList[index], 'checkAll', false)
      }
    },

    /* 批量删除 */
    allRemove(index, type) {
      let row = this.tableList[index]
      let msg = '请选择执行人'
      if (type == 3)  msg = '请选择风险责任主体单位'
      if (row.selectList.length == 0) return this.$message.error(msg)
      let arr = row.checkedList.filter(item => {
        return row.selectList.indexOf(item.id) == -1
      })
      this.$set(this.tableList[index], 'checkAll', false)
      this.$set(this.tableList[index], 'selectList', [])
      this.$set(this.tableList[index], 'checkedList', arr)
    },

    handleSelectionChange(v) {
      let arr = []
      let newArr = treeFindPath(this.departmentList,  node => node.id == this.departmentId)
      let teamInfoObj = newArr.length>0?newArr[1]:""
      let thirdDeptObj = newArr.length>0?newArr[2]:""
      v.map(i => {
        let obj = {}
        obj.id = i.id
        obj.name = i.name
        obj.departmentName = this.type != 3 ? teamInfoObj.departmentName:thirdDeptObj.departmentName,
        obj.deptId = this.type != 3 ?teamInfoObj.id:thirdDeptObj.id,
        obj.thirdDeptId = thirdDeptObj.id,
        obj.teamId = teamInfoObj.id,
        arr.push(obj)
      })
      this.selectIdsList = arr
    }
  },
};
</script>

<style lang='scss'>
.risk-release {
  flex: 1;
  width: 100%;
  background: $bg-white;
  .risk-release-container {
    height: 100%;
    position: relative;
    @include flex-column-center;
  }
  .title {
    width: 100%;
    height: 56px;
    line-height: 56px;
    padding-left: 20px;
    font-size: $fs-medium-s;
    font-weight: 400;
    color: $color-BlackGrey;
    text-align: left;
    border-bottom: 1px solid $bg-ShallowLightSnow;
    margin-bottom: 40px;
    box-sizing: border-box;
  }
  .risk-release-content {
    width: 100%;
    flex: 1;
    min-height: 703px;
    .step-content {
      @include flex-center;
      padding-top: 20px;
      margin-bottom: 90px;
      .el-form {
        width: 795px;
        .el-form-item {
          display: flex;
          .el-form-item__content {
            flex: 1;
            .el-date-editor {
              width: 100%;
            }
          }
        }
      }
      .el-tabs__header {
        margin: 0px 10px 0px 10px;
      }
      .el-tabs__content {
        padding-left: 10px;
      }
      .check-sign {
        width: 12px;
        height: 12px;
        position: absolute;
        top: 0px;
        right: 0px;
      }
      .select-type {
        height: 394px;
        border: 1px solid $bg-ShallowLightSnow;
        padding: 8px 0px 0px 0px;
        position: relative;
        .border,
        .right-border {
          height: 1px;
          background: $bg-tabs;
          position: absolute;
          top: 48px;
        }
        .border {
          width: 10px;
          left: 0px;
        }
        .right-border {
          width: 30px;
          right: 0px;
        }
        .select-container {
          height: 352px;
          position: relative;
          overflow-y: auto;
          @include scrollbarNotrack();
          .nothing {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            img {
              width: 157px;
              height: 157px;
            }
            p {
              font-size: $fs-small-l;
              font-weight: 400;
              color: $color-LightGrey;
              margin-top: 24px;
            }
          }
          .select-check-box {
            margin-top: 12px;
            background: $bg-checkbox;
            padding: 12px;
            margin-right: 10px;
            .el-checkbox {
              @include flex-start;
              white-space: pre-line;
              word-wrap: break-word;
              text-align: left;
            }
          }
        }
      }
      .details-nums {
        color: $color-grey;
        font-size: $fs-small-l;
        text-align: left;
        margin-top: 12px;
      }
    }
    .step2-content {
      @include flex-between;
      padding: 0px 24px;
      padding-top: 20px;
      margin-bottom: 86px;
      .select-company {
        width: 31%;
        border: 1px solid $bg-ShallowLightSnow;
        .select-company-title {
          @include flex-between;
          height: 44px;
          font-size: $fs-small-l;
          font-weight: 400;
          color: $color-BlackGrey;
          padding: 0px 20px;
        }
        .lable-name {
          height: 44px;
          @include flex-between;
          font-size: $fs-small-l;
          font-weight: 400;
          padding-left: 20px;
          color: $color-grey;
          background: $bg-ChangeDepartmentTree;
          border-top: 1px solid $bg-ShallowLightSnow;
          border-bottom: 1px solid $bg-ShallowLightSnow;
          .checkbox-title {
            @include flex-start;
            .el-checkbox {
              margin-right: 16px;
            }
          }
          .operation {
            width: 102px;
          }
        }
        .select-container {
          height: 444px;
          @include flex-column-center;
          padding-bottom: 20px;
          overflow-y: auto;
          @include scrollbarNotrack();
          .checkbox-title {
            flex: 1;
            width: 100%;
            .checkbox-row {
              @include flex-between;
              padding-left: 20px;
              font-size: $fs-small-l;
              color: $color-grey;
              .operation-btn {
                width: 102px;
              }
            }
          }
        }
        .all-remove {
          width: auto;
        }
      }
      .activeBtn {
        color: $color-grey!important;
      }
    }
  }
  
  .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
    height: auto;
    line-height: initial;
  }
  .foot {
    position: absolute;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;
    .el-button {
      padding: 0;
    }
    .export-tmp {
      margin-right: 20px;
    }
  }
  
  .el-dialog__body {
    position: relative;
  }
  .el-dialog .el-dialog__header {
    border-bottom: 0;
  }
  .stayDistribution {
    display: flex;
    .table-left {
      width: 470px;
      padding: 0px 16px;
      border-left: 1px solid $bg-ShallowLightSnow;
      box-sizing: border-box;
      overflow: hidden;
      .search-table {
        margin-bottom: 16px;
      }
      .assign-name {
        img {
          width: 24px;
          height: 24px;
          margin-right: 6px;
        }
      }
    }
    .table-right {
      flex: 1;
      padding: 0px 16px;
      box-sizing: border-box;
      overflow: hidden;
      .title {
        height: 36px;
        font-weight: 400;
        line-height: 36px;
        border-radius: 2px;
        margin-bottom: 14px;
        text-align: left;
        padding-left: 7px;
        font-size: $fs-small-l;
        color: $color-OriginYellow;
        background: $bg-OriginYellow;
      }
      .tree-container {
        height: 300px;
        overflow-y: auto;
        @include scrollbarNotrack(0px);
      }
    }
  }
  .department-dialog-footer {
    display: flex;
    justify-content: center;
    padding-top: 16px;
  }
}
</style>